<template>
  <DxButton class="notification">
    <div class="notification-content">
      <div style="display: flex; gap: 10px;">
        <DxButton :icon="props.icon"
                  :hoverStateEnabled="false"
                  :focusStateEnabled="false"
                  :activeStateEnabled="false"
                  class="notification-icon" />
        <div style="display: flex; align-items: center;">
          <span class="notification-text">
            {{ props.text }}
          </span>
        </div>
      </div>
      <div style="display: flex; align-items: center;">
        <span class="notification-arrow">
          >
        </span>
      </div>
    </div>
  </DxButton>
</template>

<script setup>
import { DxButton } from 'devextreme-vue';

var props = defineProps({
  icon: { type: String },
  text: { type: String }
});
</script>
<style>
.notification-icon{
  background-color: transparent !important;
}
.notification-icon .dx-icon{
  color: #03A9F4 !important;
  font-size: 16pt;
}
.notification{
  width: 100%;
  font-size: 12pt !important;
  height: 50px !important;
}
.notification-content{
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.notification-text{
  display: block;
}
.notification-arrow{
  margin-right: 10px;
  color: #DDD;
}
.dx-swatch-dark .notification-arrow{
  color: #777 !important;
}
</style>